import { jsxs as i, jsx as t } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ i("svg", { width: "48", height: "48", viewBox: "0 0 48 48", ...e, children: [
  /* @__PURE__ */ t("rect", { x: "12", y: "17", width: "18", height: "14", rx: "4", stroke: "white", strokeWidth: "2" }),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M30 26.1792V21.8208C30 21.4987 30.1551 21.1963 30.4168 21.0085L34.4167 18.1367C35.0783 17.6617 35.9999 18.1345 35.9999 18.949V29.051C35.9999 29.8655 35.0783 30.3383 34.4167 29.8633L30.4168 26.9915C30.1551 26.8037 30 26.5013 30 26.1792Z",
      stroke: "white",
      strokeWidth: "2"
    }
  )
] }), h = (e) => /* @__PURE__ */ t("svg", { width: "48", height: "48", viewBox: "0 0 48 48", ...e, children: /* @__PURE__ */ t(
  "path",
  {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M15.75 18.25h16.5m-16.5 11h16.5m-16.5-5.5h16.5"
  }
) }), o = (e) => /* @__PURE__ */ i("svg", { width: "48", height: "48", viewBox: "0 0 48 48", ...e, children: [
  /* @__PURE__ */ t("circle", { cx: "24", cy: "24", r: "24", fill: "#FB4458" }),
  /* @__PURE__ */ t("rect", { x: "12", y: "17", width: "18", height: "14", rx: "4", stroke: "white", strokeWidth: "2" }),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M30 26.1792V21.8208C30 21.4987 30.1551 21.1963 30.4168 21.0085L34.4167 18.1367C35.0783 17.6617 35.9999 18.1345 35.9999 18.949V29.051C35.9999 29.8655 35.0783 30.3383 34.4167 29.8633L30.4168 26.9915C30.1551 26.8037 30 26.5013 30 26.1792Z",
      stroke: "white",
      strokeWidth: "2"
    }
  ),
  /* @__PURE__ */ t(
    "rect",
    {
      x: "12.7266",
      y: "15.5547",
      width: "2",
      height: "26.9731",
      rx: "1",
      transform: "rotate(-45 12.7266 15.5547)",
      fill: "white"
    }
  ),
  /* @__PURE__ */ t(
    "rect",
    {
      x: "14.1406",
      y: "14.1406",
      width: "2",
      height: "26.9731",
      rx: "1",
      transform: "rotate(-45 14.1406 14.1406)",
      fill: "#FB4458"
    }
  )
] }), d = (e) => /* @__PURE__ */ i("svg", { width: "48", height: "48", viewBox: "0 0 48 48", ...e, children: [
  /* @__PURE__ */ t("path", { d: "M20 34H28", stroke: "white", strokeWidth: "2", strokeLinecap: "round" }),
  /* @__PURE__ */ t("path", { d: "M24 31V34", stroke: "white", strokeWidth: "2", strokeLinecap: "round" }),
  /* @__PURE__ */ t("rect", { x: "20", y: "13", width: "8", height: "14", rx: "4", stroke: "white", strokeWidth: "2" }),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M32 23C32 27.4183 28.4183 31 24 31C19.5817 31 16 27.4183 16 23",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round"
    }
  )
] }), s = (e) => /* @__PURE__ */ i("svg", { width: "48", height: "48", viewBox: "0 0 48 48", ...e, children: [
  /* @__PURE__ */ t("path", { d: "M20 34H28", stroke: "white", strokeWidth: "2", strokeLinecap: "round" }),
  /* @__PURE__ */ t("path", { d: "M24 31V34", stroke: "white", strokeWidth: "2", strokeLinecap: "round" }),
  /* @__PURE__ */ t("rect", { x: "20", y: "13", width: "8", height: "14", rx: "4", stroke: "white", strokeWidth: "2" }),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M32 23C32 27.4183 28.4183 31 24 31C19.5817 31 16 27.4183 16 23",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ t(
    "rect",
    {
      x: "13.7266",
      y: "15.5547",
      width: "2",
      height: "26.9731",
      rx: "1",
      transform: "rotate(-45 13.7266 15.5547)",
      fill: "white"
    }
  ),
  /* @__PURE__ */ t(
    "rect",
    {
      x: "15.1406",
      y: "14.1406",
      width: "2",
      height: "26.9731",
      rx: "1",
      transform: "rotate(-45 15.1406 14.1406)",
      fill: "currentColor"
    }
  )
] }), n = (e) => /* @__PURE__ */ t("svg", { width: "48", height: "48", viewBox: "0 0 48 48", ...e, children: /* @__PURE__ */ t("rect", { x: "16", y: "16", width: "16", height: "16", rx: "4", fill: "white" }) }), l = (e) => /* @__PURE__ */ i(
  "svg",
  {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ i("g", { clipPath: "url(#clip0_439_15484)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z",
            fill: "#F1F2FF"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M16 10C16 8.89543 16.8954 8 18 8H38C39.1046 8 40 8.89543 40 10V57H16V10Z",
            fill: "#7A82F5"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M8 24C8 22.8954 8.89543 22 10 22H27C28.1046 22 29 22.8954 29 24V48H8V24Z",
            fill: "url(#paint0_linear_439_15484)"
          }
        )
      ] }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M0.5 8C0.5 3.85787 3.85786 0.5 8 0.5H40C44.1421 0.5 47.5 3.85786 47.5 8V40C47.5 44.1421 44.1421 47.5 40 47.5H8C3.85787 47.5 0.5 44.1421 0.5 40V8Z",
          stroke: "black",
          "stroke-opacity": "0.1"
        }
      ),
      /* @__PURE__ */ i("defs", { children: [
        /* @__PURE__ */ i(
          "linearGradient",
          {
            id: "paint0_linear_439_15484",
            x1: "29",
            y1: "22",
            x2: "19.79",
            y2: "48.4492",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#BEC2FE" }),
              /* @__PURE__ */ t("stop", { offset: "1", stopColor: "#F1F2FF" })
            ]
          }
        ),
        /* @__PURE__ */ t("clipPath", { id: "clip0_439_15484", children: /* @__PURE__ */ t(
          "path",
          {
            d: "M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z",
            fill: "white"
          }
        ) })
      ] })
    ]
  }
), c = (e) => /* @__PURE__ */ i("svg", { id: "NeverUsed48", ...e, children: [
  /* @__PURE__ */ t("path", { fill: "#339D5D", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z" }),
  /* @__PURE__ */ t(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M11.097 5.071 12.5 6.5l-4.246 4.613c-.478.525-.906.507-1.403 0L4 8.5l1.403-1.429 2.15 1.9 3.544-3.9Z",
      clipRule: "evenodd"
    }
  )
] }), p = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MenuIcon: h,
  MicOffIcon: s,
  MicOnIcon: d,
  NeverUsed: c,
  NoCompanyLogo: l,
  StopOnIcon: n,
  VideoOffIcon: o,
  VideoOnIcon: r
}, Symbol.toStringTag, { value: "Module" }));
export {
  h as M,
  l as N,
  n as S,
  r as V,
  p as _,
  o as a,
  d as b,
  s as c,
  c as d
};
